import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, ChevronDown } from 'lucide-react';
const tomos = [{
  id: '01',
  title: 'ENTENDIENDO A TU HIJO ANSIOSO',
  subtitle: 'La Base que Define Todo el Sistema',
  items: ['La diferencia entre ansiedad y malacrianza', 'Los 6 tipos de ansiedad infantil', 'El ciclo ansiedad-evitación-más ansiedad', 'Por qué le duele la panza antes del colegio', 'Checklist de 15 señales de alerta', 'Tu rol real en la solución']
}, {
  id: '02',
  title: 'EL PLAN DE ACCIÓN EN CASA',
  subtitle: 'Técnicas Reales que Podés Aplicar Hoy Sin Ser Psicóloga',
  items: ['Rutina antiansiedad de mañana completa', 'Respiración del globo por edad', 'Frases exactas que calman y frases que dañan', 'El rincón de la calma: cómo crearlo hoy', 'Alimentación y sueño como herramientas', 'Protocolo específico de ansiedad escolar']
}, {
  id: '03',
  title: 'CRISIS, ESCUELA Y FUTURO',
  subtitle: 'Cómo Actuar Cuando Todo Explota y Cómo Construir un Hijo Emocionalmente Fuerte',
  items: ['Los 5 pasos cuando todo explota', 'Cómo calmarte vos primero', 'Guión completo para hablar con la maestra', 'Ansiedad nocturna: causa y solución', 'Cuándo necesitás un profesional en Argentina', 'Cómo construir un hijo emocionalmente fuerte']
}];
const bonos = [{
  id: '1',
  title: 'PROTOCOLO DE EMERGENCIA',
  items: ['Sistema de identificación de fases de crisis', 'Protocolo de acción paso a paso para cada fase', 'Tarjetas de acción rápida por tipo de crisis', 'Guión exacto palabra por palabra']
}, {
  id: '2',
  title: 'LO QUE NUNCA TE DIJERON',
  items: ['Responder el reaseguro en exceso', 'Esperar a que esté listo', 'Cada error con su corrección específica', 'Checklist de autocorrección semanal']
}, {
  id: '3',
  title: 'MI HIJO Y LA ESCUELA',
  items: ['Guión completo para hablar con la maestra', 'Carta modelo para entregar formalmente al colegio', 'Protocolo para actos y exposiciones orales', 'Cómo eliminar el síndrome del domingo a la noche']
}];
export const ProductContents = () => {
  const [openTomo, setOpenTomo] = useState<string | null>('01');
  return <section id="contents" className="relative w-full bg-white py-12 sm:py-16 md:py-20" data-id="element-251">
      <div className="mx-auto max-w-[720px] px-5" data-id="element-252">
        <div className="mb-12 text-center" data-id="element-253">
          <span className="mb-4 inline-block rounded-full bg-[#6B21A8] px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-254">
            QUÉ INCLUYE
          </span>
          <h2 className="font-heading text-3xl font-bold text-[#1A0A2E] sm:text-4xl md:text-5xl" data-id="element-255">
            El Sistema Completo.
            <br data-id="element-256" />
            <span className="text-violet-gradient" data-id="element-257">Todo Resuelto.</span>
          </h2>
        </div>

        {/* Tomos */}
        <div className="flex flex-col gap-6" data-id="element-258">
          {tomos.map(tomo => <div key={tomo.id} className="relative overflow-hidden rounded-[20px] border border-[#7C3AED]/30 bg-white shadow-card-light" data-id="element-259">
              <div className="absolute bottom-0 left-0 top-0 w-[4px] bg-violet-gradient" data-id="element-260" />
              <button onClick={() => setOpenTomo(openTomo === tomo.id ? null : tomo.id)} className="flex w-full flex-col p-6 text-left focus:outline-none sm:p-8" data-id="element-261">
                <div className="mb-4 flex items-center justify-between" data-id="element-262">
                  <span className="rounded-full bg-[#EDE9FF] px-3 py-1 text-xs font-bold text-[#6B21A8] sm:text-sm" data-id="element-263">
                    TOMO {tomo.id}
                  </span>
                  <span className="rounded-full bg-[#6B21A8] px-3 py-1 text-xs font-bold text-white sm:text-sm" data-id="element-264">
                    INCLUIDO
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-265">
                  <div data-id="element-266">
                    <h3 className="font-heading text-xl font-bold text-[#1A0A2E] sm:text-2xl" data-id="element-267">
                      {tomo.title}
                    </h3>
                    <p className="mt-1 text-sm text-[#4B3B6B]" data-id="element-268">
                      {tomo.subtitle}
                    </p>
                  </div>
                  <ChevronDown className={`ml-4 flex-shrink-0 text-[#6B21A8] transition-transform duration-300 ${openTomo === tomo.id ? 'rotate-180' : ''}`} size={24} data-id="element-269" />
                </div>
              </button>

              <AnimatePresence data-id="element-270">
                {openTomo === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-271">
                    <div className="px-6 pb-8 sm:px-8" data-id="element-272">
                      <ul className="flex flex-col" data-id="element-273">
                        {tomo.items.map((item, i) => <li key={i} className={`flex items-start gap-3 rounded-lg p-3 text-[15px] text-[#1A0A2E] ${i % 2 === 0 ? 'bg-[#F8F6FF]' : ''}`} data-id="element-274">
                            <CheckCircle2 size={20} className="mt-0.5 flex-shrink-0 text-[#6B21A8]" data-id="element-275" />
                            <span data-id="element-276">{item}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Bonos */}
        <div className="mt-8 flex flex-col gap-6" data-id="element-277">
          {bonos.map(bono => <div key={bono.id} className="relative overflow-hidden rounded-[20px] border border-[#7C3AED]/30 bg-white p-6 shadow-card-light sm:p-8" data-id="element-278">
              <div className="absolute bottom-0 left-0 top-0 w-[4px] bg-[#D4A017]" data-id="element-279" />
              <div className="absolute right-0 top-0 rounded-bl-xl bg-[#D4A017] px-3 py-1 text-xs font-bold text-[#1A0A2E]" data-id="element-280">
                BONO GRATIS
              </div>
              <div className="mb-5" data-id="element-281">
                <h3 className="mt-2 font-heading text-xl font-bold text-[#1A0A2E] sm:text-2xl" data-id="element-282">
                  {bono.title}
                </h3>
              </div>
              <ul className="flex flex-col gap-2" data-id="element-283">
                {bono.items.map((item, i) => <li key={i} className={`flex items-start gap-3 rounded-lg p-3 text-[15px] text-[#1A0A2E] ${i % 2 === 0 ? 'bg-[#F8F6FF]' : ''}`} data-id="element-284">
                    <CheckCircle2 size={20} className="mt-0.5 flex-shrink-0 text-[#6B21A8]" data-id="element-285" />
                    <span data-id="element-286">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Value Stack */}
        <div className="mt-12" data-id="element-287">
          <div className="mx-auto max-w-[420px] rounded-[16px] border border-[#7C3AED]/30 bg-white p-6 shadow-[0_0_20px_rgba(124,58,237,0.15)] sm:p-8" data-id="element-288">
            <h3 className="mb-6 text-center font-heading text-xl font-bold text-[#1A0A2E]" data-id="element-289">
              VALOR TOTAL DEL KIT
            </h3>
            <div className="flex flex-col gap-3 text-sm font-medium text-[#4B3B6B] sm:text-base" data-id="element-290">
              <div className="flex justify-between" data-id="element-291">
                <span data-id="element-292">Tomo 1</span>
                <span className="text-[#9B8EC4] line-through" data-id="element-293">$15.000</span>
              </div>
              <div className="flex justify-between" data-id="element-294">
                <span data-id="element-295">Tomo 2</span>
                <span className="text-[#9B8EC4] line-through" data-id="element-296">$15.000</span>
              </div>
              <div className="flex justify-between" data-id="element-297">
                <span data-id="element-298">Tomo 3</span>
                <span className="text-[#9B8EC4] line-through" data-id="element-299">$15.000</span>
              </div>
              <div className="flex justify-between" data-id="element-300">
                <span data-id="element-301">Bono 1</span>
                <span className="text-[#D4A017]" data-id="element-302">GRATIS</span>
              </div>
              <div className="flex justify-between" data-id="element-303">
                <span data-id="element-304">Bono 2</span>
                <span className="text-[#D4A017]" data-id="element-305">GRATIS</span>
              </div>
              <div className="flex justify-between" data-id="element-306">
                <span data-id="element-307">Bono 3</span>
                <span className="text-[#D4A017]" data-id="element-308">GRATIS</span>
              </div>
            </div>

            <div className="my-6 h-px w-full bg-violet-gradient" data-id="element-309" />

            <div className="text-center" data-id="element-310">
              <p className="text-lg font-bold text-[#9B8EC4] line-through sm:text-xl" data-id="element-311">
                VALOR TOTAL: $52.000
              </p>
              <p className="mt-2 font-heading text-4xl font-black text-violet-gradient sm:text-5xl" data-id="element-312">
                HOY SOLO: $19.990
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};